import { Box, Typography, Grid, Button } from "@mui/material";

import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import PhoneInTalkIcon from "@mui/icons-material/PhoneInTalk";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

function Contact() {
  const phoneNumber = "+201207158439";
  const whatsappNumber = "201270567657";

  return (
    <section id="contact" className="contact-section">
      <div className="contact-container">
        {/* Header */}
        <div className="contact-header">
          <span className="contact-badge">
            <span>✦</span> تواصل معانا
          </span>

          <Typography variant="h2" className="contact-title">
            عندك سؤال؟
            <br />
            <span>إحنا هنا عشان نساعدك</span>
          </Typography>

          <p className="contact-description">
            عايز تعرف تفاصيل الحصص أو المواعيد أو الأماكن؟
            <br />
            تواصل معانا واختار الطريقة الأنسب ليك.
          </p>
        </div>

        {/* Contact Cards */}
        <Grid container spacing={3} className="contact-grid">
          {/* Phone */}
          <Grid item xs={12} md={6}>
            <Box className="contact-card phone-card">
              <div className="contact-card-top">
                <div className="contact-icon phone-icon">
                  <PhoneInTalkIcon />
                </div>

                <span className="contact-card-badge">مكالمة مباشرة</span>
              </div>

              <h3>اتصل بينا</h3>

              <p>
                لو عندك أي استفسار عن الحصص أو المواعيد، كلّمنا مباشرة وهتلاقي
                حد يساعدك.
              </p>

              <a href={`tel:${phoneNumber}`} className="contact-number">
                <LocalPhoneIcon />
                <strong>+20 120 715 8439</strong>
              </a>
              <br/> 
              <a href={`tel:${phoneNumber}`} className="contact-number">
                <LocalPhoneIcon />
                <strong>+20 127 0567 657</strong>
              </a>
              <div className="contact-availability">
                <AccessTimeIcon />
                <span>
                  متاحين يوميًا من <strong>9 صباحًا</strong> حتى{" "}
                  <strong>10 مساءً</strong>
                </span>
              </div>

              <Button
                component="a"
                href={`tel:${phoneNumber}`}
                className="contact-action phone-action"
                endIcon={<ArrowBackIcon />}
              >
                اتصل دلوقتي
              </Button>
            </Box>
          </Grid>

          {/* WhatsApp */}
          <Grid item xs={12} md={6}>
            <Box className="contact-card whatsapp-card">
              <div className="contact-card-top">
                <div className="contact-icon whatsapp-icon">
                  <WhatsAppIcon />
                </div>

                <span className="contact-card-badge">أسرع طريقة</span>
              </div>

              <h3>راسلنا على واتساب</h3>

              <p>ابعتلنا رسالتك على واتساب واستفسر عن كل التفاصيل بسهولة.</p>

              <a
                href={`https://wa.me/${whatsappNumber}`}
                target="_blank"
                rel="noopener noreferrer"
                className="contact-number"
              >
                <WhatsAppIcon />
                <strong>+20 127 0567 657</strong>
              </a>

              <div className="contact-availability">
                <AccessTimeIcon />
                <span>
                  متاحين يوميًا من <strong>9 صباحًا</strong> حتى{" "}
                  <strong>10 مساءً</strong>
                </span>
              </div>

              <Button
                component="a"
                href={`https://wa.me/${whatsappNumber}`}
                target="_blank"
                rel="noopener noreferrer"
                className="contact-action whatsapp-action"
                endIcon={<ArrowBackIcon />}
              >
                ابعتلنا على واتساب
              </Button>
            </Box>
          </Grid>
        </Grid>

        {/* Bottom CTA */}
        <div className="contact-bottom">
          <div>
            <span className="contact-bottom-label">PureEng</span>

            <h3>مستنيين رسالتك 👋</h3>

            <p>فريقنا جاهز يجاوب على استفساراتك ويساعدك تبدأ صح.</p>
          </div>

          <div className="contact-bottom-decoration">
            <span>English</span>
            <strong>+</strong>
            <span>Practice</span>
            <strong>+</strong>
            <span>Success</span>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
